import { FunctionComponent } from 'react';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { useDispatch } from '@cbridge-utils/react-redux';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { IDetailsSidebarHeaderProps } from './DetailsSidebarHeader.interface';

const HeaderStack = styled(Stack)(({ theme }) => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderBottom: '1px solid var(--mui-palette-divider)',
}));

export const DetailsSidebarHeader: FunctionComponent<IDetailsSidebarHeaderProps> = (props) => {
  const { children, onClose } = props;

  const dispatch = useDispatch();

  const handleClose = async () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(DetailsSidebarAction.close());
    }
  };

  return (
    <HeaderStack direction={'row'}>
      <Stack direction={'row'} sx={{
        gap: 2,
      }}>
        {children}
      </Stack>
      <IconButton
        size={'small'}
        color={'inherit'}
        aria-label={'close'}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
    </HeaderStack>
  );
};
